


// icons
import { FiMenu, FiTwitter } from "react-icons/fi"
import { AiOutlineClose } from "react-icons/ai"
import openseaIcon from "assets/images/others/opensea.svg"

// css
import "./header.css"
import { useState } from "react"


// ==== header component ====
const Header = () => {
    // 
    const [menuOpen,setMenuOpen] = useState(null)
    // scroll to related section
    const scrollTo_Section = (sec_id) => {
        if (sec_id === "home") {
            window.scrollTo(0, 0);
            return
        }
        let element = document.getElementById(sec_id);
        var yOffset = -50;

        if (element) {
            const y =
                element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: "smooth" });
        }
    };

    // close menu
    const closeMenu = () => {
        setMenuOpen(false);
    };
    return (
        <header className='web-header' id="web-header">
            <div className="cs_container">
                <div className="cs_row header_row align-items-center">
                    <div className="header_logo">
                        <img onClick={() => { scrollTo_Section("home"); closeMenu() }} width="120" height="" src="/logo.png" alt="SPACE WARRIORS" />
                    </div>
                    <nav className={`header_nav ${menuOpen ? "menu_opened" : ""}`}>
                        <div className="nav_logo align-items-center justify-content-center">
                            <img onClick={() => { scrollTo_Section("home"); closeMenu() }} width="140" height="" src="/logo.png" alt="SPACE WARRIORS" />
                            <span onClick={closeMenu} className="cta-btn menu-btn">
                                <AiOutlineClose />
                            </span>
                        </div>
                        <ul className="d_flex align-items-center justify-content-end">
                            <li>
                                <span onClick={() => {scrollTo_Section("about"); closeMenu()}} className="navlink">
                                    About
                                </span>
                            </li>
                            <li>
                                <span onClick={() => {scrollTo_Section("factions"); closeMenu()}} className="navlink">
                                    Factions
                                </span>
                            </li>
                            <li>
                                <span onClick={() => {scrollTo_Section("roadMap"); closeMenu()}} className="navlink">
                                    Roadmap
                                </span>
                            </li>
                            {/* <li>
                            // http://staking.spacewarriorsclub.com/
                                <p onClick={closeMenu} className="navlink" title="Coming soon">
                                    Stake 
                                    <span className="label">Coming soon</span>    
                                </p>
                            </li> */}
                            {/* <li>
                                <a onClick={closeMenu} href="http://merch.spacewarriorsclub.com/" target="_blank" rel="noopener noreferrer" className="navlink">
                                    Merch
                                </a>
                            </li> */}
                            <li>
                                <a onClick={closeMenu} href="https://snapshot.org/#/space-warriors.eth" target="_blank" rel="noopener noreferrer" className="navlink">
                                    Dao
                                </a>
                            </li>
                        </ul>
                    </nav>
                    <div className="header_right d_flex align-items-center justify-content-end">
                        <a onClick={closeMenu} href="https://twitter.com/swcNFT" target="_blank" rel="noopener noreferrer" className="cta-btn">
                            <FiTwitter />
                        </a>
                        <a onClick={closeMenu} href="https://opensea.io/collection/thespacewarriorsclub" target="_blank" rel="noopener noreferrer" className="cta-btn">
                            <img src={openseaIcon} loading="lazy" width="32" alt="Opensea" />
                        </a>
                        <span onClick={() => setMenuOpen((prev)=> !prev)} className="cta-btn menu-btn">
                            <FiMenu />
                        </span>
                    </div>
                  {menuOpen ?  <div onClick={closeMenu} className="header_backdrop"></div> : null}
                </div>
            </div>
        </header>
    )
}

export default Header